import React from 'react';
import { motion } from 'framer-motion';

const Star = () => (
  <span className="text-amber-400 text-lg leading-none">{'\u2726'}</span>
);

const TestimonialCard = ({ text, stars = 5, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-50px' }}
    transition={{ duration: 0.7, delay: index * 0.1 }}
    className="flex-1 min-w-[260px] max-w-md text-center px-4"
  >
    <div className="flex justify-center gap-1 mb-4 tracking-widest">
      {Array.from({ length: stars }).map((_, i) => (
        <Star key={i} />
      ))}
    </div>
    <p
      className="text-white/95 italic font-light leading-relaxed text-base md:text-lg"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      {'\u201c'}{text}{'\u201d'}
    </p>
  </motion.div>
);

export const TestimonialsRow = ({ items }) => (
  <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
    <div className="bg-white/15 backdrop-blur-md rounded-3xl border border-white/25 p-8 md:p-14 shadow-2xl">
      <div className="flex flex-col md:flex-row items-start justify-between gap-8">
        {items.map((t, idx) => (
          <TestimonialCard key={t.id} text={t.text} stars={t.stars} index={idx} />
        ))}
      </div>
    </div>
  </div>
);

export const SingleTestimonial = ({ item }) => (
  <div className="max-w-3xl mx-auto px-6 py-14 text-center">
    <div className="flex justify-center gap-1 mb-4">
      {Array.from({ length: item.stars }).map((_, i) => (
        <Star key={i} />
      ))}
    </div>
    <p
      className="text-white italic font-light text-lg md:text-xl leading-relaxed"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      {'\u201c'}{item.text}{'\u201d'}
    </p>
  </div>
);

export default TestimonialsRow;
